<template>
  <!-- 使用记录列表（仪器列表） -->
  <div class="exportModel">
    <div class="model-detail" v-if="itemData">
      <div class="box-detail">
        <span class="box-title">仪器名称：</span>
        <span class="box-content">{{itemData.instrumentName}}</span>
      </div>
      <div class="box-detail">
        <span class="box-title">型号：</span>
        <span class="box-content">{{itemData.pattern}}</span>
      </div>
      <div class="box-detail">
        <span class="box-title">仪器编号：</span>
        <span class="box-content">{{itemData.serialNumber}}</span>
      </div>
      <div class="box-detail">
        <span class="box-title">检定/校准有效期：</span>
        <span class="box-content">{{itemData.validityEffectiveTime}}</span>
      </div>
      <div class="box-detail">
        <span class="box-title">不确定度/准确度：</span>
        <span class="box-content">{{itemData.accuracy}}</span>
      </div>
      <div class="box-detail">
        <span class="box-title">量程：</span>
        <span class="box-content">{{itemData.range}}</span>
      </div>
    </div>
    <div style="margin-bottom: 10px;">
      <span class="box-title" style="margin-left: 10px;">使用日期范围：</span>
      <el-date-picker format="yyyy-MM-dd" size="mini" value-format="yyyy-MM-dd" v-model="date" type="daterange" range-separator="至"
                       start-placeholder="开始日期" end-placeholder="结束日期">
       </el-date-picker>
          <el-select class="element-list" size="small" :poper-append-to-body="false" popper-class="my-select" clearable
            v-model="useType" placeholder="请选择使用类型">
            <el-option v-for="item in useTypeLst" :key="item.key" :label="item.value" :value="item.key">
            </el-option>
          </el-select>
       <el-button type="primary" size="mini"  @click="inquire">搜索</el-button>
       <el-button type="" size="mini"  @click="derive">导出</el-button>
    </div>
    <div class="model-use-his sysTable">
      <el-table :data="record" height="450" v-loading="tLoading" style="width: 100%">
        <el-table-column prop="lendOpenTime" label="日期" align="center" width="150">
          <template slot-scope="scope">
              {{ interceptionDate(scope.row.lendOpenTime) }}
            </template>
        </el-table-column>
        <el-table-column align="center" label="使用前检查">
          <el-table-column prop="beforeUseStates" label="正常" align="center" w>
            <template slot-scope="scope">
              <span v-if="scope.row.beforeUseStates == 0">
                <i class="el-icon-check"></i>
              </span>
              <span v-else></span>
            </template>
          </el-table-column>
          <el-table-column prop="beforeUseStates"  align="center" label="异常">
            <template slot-scope="scope">
              <span v-if="scope.row.beforeUseStates == 1">
                <i class="el-icon-close"></i>
              </span>
              <span v-else></span>
            </template>
          </el-table-column>
          <el-table-column prop="beforeTime" width="150" align="center" label="时间">
            <template slot-scope="scope">
              {{ interceptionDate(scope.row.beforeTime) }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column align="center" label="使用后检查">
          <el-table-column prop="afterUseStates" label="正常" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.afterUseStates == 0">
                <i class="el-icon-check"></i>
              </span>
              <span v-else></span>
            </template>
          </el-table-column>
          <el-table-column prop="afterUseStates"  align="center" label="异常">
            <template slot-scope="scope">
              <span v-if="scope.row.afterUseStates == 1">
                <i class="el-icon-close"></i>
              </span>
              <span v-else></span>
            </template>
          </el-table-column>
          <el-table-column prop="afterTime" align="center" label="时间" width="150">
            <template slot-scope="scope">
              {{ interceptionDate(scope.row.afterTime) }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column prop="userName" label="检查人" align="center" >
        </el-table-column>
        <el-table-column prop="useType" label="使用类型" align="center" >
                  <template slot-scope="scope">{{ scope.row.useType==1?'项目':scope.row.useType==2?'保养':scope.row.useType==3?'检定校准':scope.row.useType==4?'维修':'/' }}</template>
        </el-table-column> 
        <el-table-column prop="projectName" label="工程名称" align="center"  width="150">
        </el-table-column>
          <el-table-column prop="remark" label="备注" align="center"  width="250">
        </el-table-column>
        <el-table-column  fixed="right"
        label="操作"  align="center" width="100">
        <template slot-scope="{row}">
          <el-popconfirm
  title="确定删除吗？"
  @confirm="handleClick(row)"
>
  <el-button   slot="reference" type="text" size="small">删除</el-button>
</el-popconfirm>
       
      </template>
        </el-table-column>
      </el-table>
      <div class="resource-block">
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="current"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    </div>
    </div>
  </div>
</template>
<!-- 分页展示 -->
<script>
import { getRecordByIns, batchExportByIns,deleteUseInfoId } from "@/api/depotApi";
export default {
  name: "exportModel",
  props: {
    insId: Number,
    itemData:Object,
    exPosp:Boolean
  },
  data() {
    return {
      dataDetail: {},
      tLoading: true,
      current:1,
      total:0,
      size:10,
      date:null,
      useType:'',
      record:[],
      useTypeLst:[
      { key: 1, value: "项目" },
        { key: 2, value: "保养" },
        { key: 3, value: "检定校准" },
        { key: 4, value: "维修" },
      ],

    };
  },
  mounted() {
    this.getRecordByIns();
  },
  watch: {
    insId() {
      this.getRecordByIns();
    },
    exPosp:{
      handler(newVal, oldVal) {
        this.date = null
        this.useType = ''
        this.getRecordByIns();
      // 处理变化
    },
    deep: true
    }
  },
  methods: {
    interceptionDate(date){
      if(date){
        return date.substring(0, 16);
      }
    },
    inquire(){
      this.current = 1;
      this.getRecordByIns()
    },
  async  handleClick(row){
      const res = await deleteUseInfoId(row.useInfoId)
      let {code,msg,data} = res
      if(code !=200){
        this.$message({
          message: msg,
          type: 'warning'
        });
        return
      }
      this.getRecordByIns();

    },
    handleSizeChange(page){
      this.size = page;
      this.getRecordByIns()
    },
    handleCurrentChange(page){
      this.current = page;
      this.getRecordByIns();
    },
    //获取使用记录
    getRecordByIns() {
      let self = this;
      self.tLoading = true;
      let data = {
        current: self.current,
      size:self.size,
        id: self.insId,
        useType:self.useType
      };
      if (this.date) {
        data.startDate = this.date[0]
        data.endDate = this.date[1]
            }
      getRecordByIns(data)
        .then((res) => {
          self.tLoading = false
          if (res.code == 200) {
            self.record = res.data.records;
            self.total = res.data.total;
          
          }
        })
        .finally(() => (self.tLoading = false));
    },
    //导出使用记录
    derive() {
      let data = {
       startDate:this.date&&this.date.length?this.date[0]:'',
       endDate:this.date&&this.date.length?this.date[1]:'',
        insId: this.insId,
        useType:this.useType
      };
      batchExportByIns(data).then((res) => {
        this.mixin.blobDownload(res.data,'使用记录.docx');
      });
    },
  },
};
</script>

<style lang="less" scoped>
.exportModel {

  .model-title {
    text-align: center;
    .tit-button {
      float: right;
      margin-right: 1%;
    }
  }
  .model-detail {
    width: 100%;
    display: grid; //网格形式
    grid-template-columns: 33% 33% 33%; //这里表明分为3列
    grid-gap: 10px; //每列的间隔
    .box-detail {
      height: 32px;
      line-height: 32px;
      padding: 0px 12px;
      border-radius: 6px;
      margin-right: 10px;
      .box-title {
        width: 35%;
      }
      .box-content {
        width: 65%;
      }
    }
  }
  .model-bottom {
    margin-top: 20px;
  }
}
.resource-block{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

</style>



// WEBPACK FOOTER //
// src/views/Instrumentmanagemen/components/exportModel.vue